module.exports = __webpack_public_path__ + "static/media/diamond-white.5dfa715e.gif";